module.exports = __webpack_public_path__ + "static/media/twitter.1db9e9c3.svg";